import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { DialogConfirmRequest, DialogConfirmResponse, FeatureFlag, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, MenuFuncionTenant, SaveTenantDto, SearchTipoResponsableIvaRequest, Tenant, TenantDiccionarioDto, TenantFeatureFlagEnum } from '../../../../src/app/shared/model';

import { MenuFuncionService, TenantService, TipoResponsableIvaService } from '../../../../src/app/shared/services';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-tenantEdit',
  templateUrl: './tenantEdit.component.html',
  styleUrls: ['tenantEdit.component.scss']
})

export class TenantEditComponent implements OnInit {
  @ViewChild('menuTenantGrid')
  public menuTenantGrid: GridComponent;
  @ViewChild('tenantDiccionarioGrid')
  public tenantDiccionarioGrid: GridComponent;

  formGroup: FormGroup;
  tenantId: number;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoResponsableSearching: boolean = false;
  isFeatureFlagSearching: boolean = false;

  canView: boolean = false;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdminEdit: boolean = false;
  copiarTenant: boolean = false;

  seleccionarTodosMenues: boolean = false;

  isTenantDiccionarioSearching: boolean = false;
  menuTenantList: MenuFuncionTenant[];

  isMenuTenantSearching: boolean = false;
  tenantDiccionarioList: TenantDiccionarioDto[];
  featureFlagList: FeatureFlag[];

  msgError: string = "";
  item: Tenant;
  tenantImageBase64: string | ArrayBuffer | null;
  tenantImageExtension: string = "";
  tipoResponsableList: any[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService,
    private tipoResponsableIvaService: TipoResponsableIvaService,
    private menuService: MenuFuncionService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Verifica si la URL contiene "tenant-copy", se quiere realizar un copiado de tenant
        if (this.router.url.includes('tenant-copy'))
          this.copiarTenant = true;
      }
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.TENANT).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.TENANT_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.TENANT_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.TENANT_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.TENANT_DELETE);
        this.canAdminEdit = data.Result.some(x => x == MenuFuncionCodes.TENANT_ADMIN);

        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();

    this.loadEntity();

    this.getTiposComprobantes();
    this.getAllTenantFeatureFlags();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'NombreCorto': [null],
      'NroDocumento': [null],
      'TipoResponsableIvaId': [null],
      'NumeroMatriculaRpa': [null, Validators.maxLength(50)],
      'Telefono': [null],
      'Direccion': [null],
      'Email': [null],
      'SitioWeb': [null],
      'FeatureFlags': [null]
    });
  }

  getTiposComprobantes() {
    var r = new SearchTipoResponsableIvaRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoResponsableSearching = true;

    this.tipoResponsableIvaService.search(r).subscribe(data => {
      this.isTipoResponsableSearching = false;
      this.tipoResponsableList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoResponsableSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMenuTenants(id: number) {
    if (id == null || id < 0)
      return;

    this.isMenuTenantSearching = true;
    this.tenantService.getTenantMenusById(id).subscribe(data => {
      this.isMenuTenantSearching = false;
      this.menuTenantList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isMenuTenantSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTenantDiccionario(id: number) {
    if (id == null || id < 0)
      return;

    this.isTenantDiccionarioSearching = true;
    this.tenantService.getTenantDiccionarioById(id).subscribe(data => {
      this.isTenantDiccionarioSearching = false;
      this.tenantDiccionarioList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTenantDiccionarioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAllTenantFeatureFlags() {
    this.isFeatureFlagSearching = true;
    this.tenantService.getAllFeatureFlags().subscribe(data => {
      this.isFeatureFlagSearching = false;
      this.featureFlagList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isFeatureFlagSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  compareFeatureFlags(o1: number, o2: number): boolean {
    return o1 == o2;
  }

  convertFileToBase64(event) {
    this.tenantImageBase64 = null;
    const file = event.target.files[0];

    if (file != null) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
      };
      reader.onloadend = () => {
        this.tenantImageBase64 = reader.result;
        this.tenantImageExtension = (file?.name?.split('.')?.pop() ?? "");
        // console.log(reader.result);
      };
    }
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isValidating);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0' && params['id'] != '00') {
        this.tenantId = Number(params['id']);

        if (this.tenantId > 0)
          this.loadData();
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (params['id'] == '00') {
          var v1 = Number(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId));
          if (v1 != null && v1 > 0) {
            this.tenantId = v1;
            this.loadData();
          }
        }
        else {
          if (this.canAdd) {
            this.item = new Tenant(0, null, null, null, null, null, null, null, null, null, null, true, []);
            this.formGroup.patchValue(this.item);
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
      }
    });
  }

  loadData() {
    if (this.canView || (this.canEdit || (this.copiarTenant && this.canAdd))) {
      this.isSearching = true;
      this.tenantService.get(this.tenantId).subscribe(data => {
        this.isSearching = false;
        if (data != null && data.Success) {
          this.item = data.Result;

          if (this.item != null && this.item.Id > 0) {
            this.getMenuTenants(this.item.Id);
            this.getTenantDiccionario(this.item.Id);

            if ((this.copiarTenant && this.canAdd) || this.canEdit || this.canAdminEdit) {
              this.formGroup.patchValue(this.item);
              this.formGroup.get("FeatureFlags")?.setValue(this.item.FeatureFlags?.map(s => s.Id));
            }

            if (this.copiarTenant && this.canAdd) {
              this.item.Id = 0;
              this.formGroup.get("Id")?.setValue(0);
            }
          }
          else
            this.msgError = "No se encontró la administración seleccionada.";
        }
        else
          this.msgError = "Ocurrió un error al intentar obtener los datos de la administración.";
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
    else {
      this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
      this.onCancel();
    }
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorNumeroMatriculaRpa() {
    var v = this.formGroup.get('NumeroMatriculaRpa');
    if (v?.hasError('maxlength'))
      return 'Límite de 50 caracteres alcanzado';
    return '';
  }

  tenantImageChanged() {
    return (this.tenantImageBase64 != null);
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var nombreCorto = this.formGroup.get("NombreCorto")?.value;
    if (nombreCorto == null || nombreCorto.length == 0)
      this.formGroup.get("NombreCorto")?.setValue(this.formGroup.get("Nombre")?.value);

    var index = this.tenantImageBase64?.toString()?.indexOf(",");
    var r = new SaveTenantDto(0, null, null, null, null, null, null, null, null, null, null, null, true, []);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        FotoLogoBase64: (index != null && index >= 0 ? this.tenantImageBase64?.toString()?.substring(index+1) : null),
        FotoLogoExtension: this.tenantImageExtension,
        Activo: (this.item?.Activo ?? true),
        Menues: this.menuTenantList?.filter(f => f != null && f.Asociado),
        Diccionario: this.tenantDiccionarioList
      }
    };

    this.isSaving = true;
    this.tenantService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

  onTenantDiccionarioFieldChange(key: string | null, event: any) {
    if (key != null && key.length > 0 && this.tenantDiccionarioList != null) {
      for (var i=0; i < this.tenantDiccionarioList.length; i++) {
        if (this.tenantDiccionarioList[i].Key == key)
          this.tenantDiccionarioList[i].NombreMostrar = event.target.value;
      }
    }
  }

  onMenuTenantFieldChange(menuId: number, fieldName: string | null, value: any) {
    // console.log("menuId: " + menuId + " - fieldName: " + fieldName + " - value: " + value);
    if (menuId != null && menuId > 0 && this.menuTenantList != null) {
      var index = this.menuTenantList?.findIndex(f => f.MenuFuncionId == menuId);
      if (index >= 0) {
        switch (fieldName) {
          case "Nombre":
            this.menuTenantList[index].Nombre = value;
            break;
          case "Orden":
            this.menuTenantList[index].Orden = value;
            break;
          case "Icono":
            this.menuTenantList[index].Icono = value;
            break;
          case "Asociado":
            this.menuTenantList[index].Asociado = value;
            this.getMenuHeaderText();
            // if (this.menuTenantList[index].Nombre == null || this.menuTenantList[index].Nombre.length == 0)
            //   this.menuTenantList[index].Nombre = this.menuTenantList[index].MenuFuncionNombre;
            break;
        }

        this.menuTenantGrid.refresh();
      }
    }
  }

  onMenuSeleccionarTodos(event: any) {
    // console.log("onMenuSeleccionarTodos: " + this.seleccionarTodosMenues, event);

    if (this.menuTenantList != null && this.menuTenantList.length > 0) {
      for (var i=0; i < this.menuTenantList.length; i++) {
        this.onMenuTenantFieldChange(this.menuTenantList[i].MenuFuncionId, 'Asociado', event.checked);
      }
    }
  }

  onModuloHabilitarTodos(event: any){
    // this.item.HabilitarControlExpensas = event.checked;
    // this.item.HabilitarControlPedidos = event.checked;
  }

  getMenuHeaderText() {
    // menuTenantList != null ? '(' getTotalMenuesAsociados() + ' de ' + menuTenantList.length + ' menues totales)' : ''
    if (this.menuTenantList != null)
      return "(" + (this.menuTenantList?.filter(f => f.Asociado)?.length ?? 0) + " de " + this.menuTenantList.length + " menues totales)";
    return "";
  }

  onDelete() {
    if (!this.canDelete)
        return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el item?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.tenantService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  checkGestionConsorcio() {
    return (this.formGroup?.get("FeatureFlags")?.value?.some(f => f == TenantFeatureFlagEnum.GestionConsorcio) ?? false);
  }
}
